var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"back-btn",on:{"click":_vm.onPressed}},[_c('img',{attrs:{"src":require("../assets/arrow-left.svg")}}),_c('div',[_vm._v("Back")])])}
var staticRenderFns = []

export { render, staticRenderFns }